import { generateRecentIsoTimestamp } from "utils/timestamp";
const busInfo = {
  busInfo: [
    {
      busNo: "1",
      licensePlateNo: "PB1672",
      regionDepo: "Abu Dhabi",
      totalTrips: "1458",
      safetyScore: "85",
      totalPassengers: "25896",
      totalMiles: "1500",
      avgFuelEconomy: "40 Miles/Gal",
      nextMaintanance: "09-25-2025",
      trips: [
        {
          tripNo: "1",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "In Progress",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#1",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5015",
                    lng: "54.3850"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4667",
                    lng: "54.3333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4885",
                    lng: "54.6050"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.5167"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "3",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#3",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Ain City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.2075",
                    lng: "55.7447"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Faqa, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5833",
                    lng: "55.5833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Dhafra, Abu Dhabi",
                  coOrdinates: {
                    lat: "23.6530",
                    lng: "53.7052"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Musaffah Industrial Area, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.3500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Shakhbout City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.3833",
                    lng: "54.5333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Abu Dhabi International Airport",
                  coOrdinates: {
                    lat: "24.4330",
                    lng: "54.6511"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "4",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#4",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Saadiyat Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5333",
                    lng: "54.4000"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Zahiyah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Mina, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Mushrif, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4000"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Manhal, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.3833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Sheikh Zayed Grand Mosque",
                  coOrdinates: {
                    lat: "24.4122",
                    lng: "54.4747"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "5",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#5",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Shamkha, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.3000",
                    lng: "54.5667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Wathba, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.2500",
                    lng: "54.5833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Bani Yas, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.2833",
                    lng: "54.6167"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Falah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Nahyan, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Muroor, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "6",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#6",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5015",
                    lng: "54.3850"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4667",
                    lng: "54.3333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4885",
                    lng: "54.6050"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "7",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#7",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.5167"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentIsoTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentIsoTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentIsoTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentIsoTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentIsoTimestamp(),
        },
      ],
    },
    {
      busNo: "2",
      licensePlateNo: "AD4589",
      regionDepo: "Khalifa City",
      totalTrips: "1320",
      safetyScore: "92",
      totalPassengers: "22450",
      totalMiles: "1420",
      avgFuelEconomy: "38 Miles/Gal",
      nextMaintanance: "09-12-2025",
      trips: [
        {
          tripNo: "1",
          speed: "12 mph",
          fuelConsumed: "18 Gal",
          distanceCovered: "22 Miles",
          driver: "Mohammed Al Qubaisi",
          tripStatus: "Completed",
          distance: "120 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "25/40",
            videoUrl: "http://busVideo2",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Khalifa City",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Al Bahia",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "5 Min Delay",
                  area: "Al Raha Beach",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Raha Gardens",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 4",
                  observation: "",
                  area: "Khalifa Park",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.5167"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Al Raha Mall",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "15 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "25 Miles",
          driver: "Mohammed Al Qubaisi",
          tripStatus: "In Progress",
          distance: "130 Miles",
          routeDetails: {
            route: "Route#2A",
            occupancy: "30/40",
            videoUrl: "http://busVideo2A",
            routeStops: {
              totalStops: "5",
              stopsCovered: "2",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Al Raha Mall",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Heavy Traffic",
                  area: "Al Raha Gardens",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bahia",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Shakhbout City",
                  coOrdinates: {
                    lat: "24.3833",
                    lng: "54.5333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Abu Dhabi International Airport",
                  coOrdinates: {
                    lat: "24.4330",
                    lng: "54.6511"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "3",
          speed: "14 mph",
          fuelConsumed: "19 Gal",
          distanceCovered: "24 Miles",
          driver: "Mohammed Al Qubaisi",
          tripStatus: "Scheduled",
          distance: "125 Miles",
          routeDetails: {
            route: "Route#2B",
            occupancy: "28/40",
            videoUrl: "http://busVideo2B",
            routeStops: {
              totalStops: "6",
              stopsCovered: "0",
              stoppages: [
                {
                  name: "Source",
                  observation: "Scheduled",
                  area: "Abu Dhabi International Airport",
                  coOrdinates: {
                    lat: "24.4330",
                    lng: "54.6511"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Shakhbout City",
                  coOrdinates: {
                    lat: "24.3833",
                    lng: "54.5333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bahia",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Raha Beach",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 4",
                  observation: "",
                  area: "Al Raha Gardens",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Khalifa City",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        }
      ],
      pastViolations: [
        {
          violationType: "rash driving",
          busNo: "2",
          route: "Route#2",
          timeStamp: generateRecentIsoTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "2",
          route: "Route#2",
          timeStamp: generateRecentIsoTimestamp(),
        },
      ],
    },
    {
      busNo: "3",
      licensePlateNo: "CR6721",
      regionDepo: "Guatuso",
      totalTrips: "980",
      safetyScore: "88",
      totalPassengers: "18760",
      totalMiles: "1120",
      avgFuelEconomy: "36 Miles/Gal",
      nextMaintanance: "17-10-2025",
      trips: [
        {
          tripNo: "1",
          speed: "14 mph",
          fuelConsumed: "22 Gal",
          distanceCovered: "25 Miles",
          driver: "Ana Rodriguez",
          tripStatus: "Completed",
          distance: "135 Miles",
          routeDetails: {
            route: "Route#3",
            occupancy: "28/40",
            videoUrl: "http://busVideo3",
            routeStops: {
              totalStops: "5",
              stopsCovered: "5",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "San Rafael de Guatuso",
                  coOrdinates: {
                    lat: "",
                    lng: "",
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "La Fortuna",
                  coOrdinates: {
                    lat: "",
                    lng: "",
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "10 Min Delay",
                  area: "El Tanque",
                  coOrdinates: {
                    lat: "",
                    lng: "",
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Rio Cuarto",
                  coOrdinates: {
                    lat: "",
                    lng: "",
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Pocosol",
                  coOrdinates: {
                    lat: "",
                    lng: "",
                  },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "18 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "30 Miles",
          driver: "Carlos Jimenez",
          tripStatus: "Completed",
          distance: "142 Miles",
          routeDetails: {
            route: "Route#4",
            occupancy: "35/40",
            videoUrl: "http://busVideo4",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Quesada",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Florencia",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "5 Min Delay",
                  area: "Santa Clara",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Venecia",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 4",
                  observation: "On Time",
                  area: "Los Chiles",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Upala",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "3",
          speed: "12 mph",
          fuelConsumed: "19 Gal",
          distanceCovered: "22 Miles",
          driver: "Maria Fernandez",
          tripStatus: "Completed",
          distance: "120 Miles",
          routeDetails: {
            route: "Route#5",
            occupancy: "30/40",
            videoUrl: "http://busVideo5",
            routeStops: {
              totalStops: "4",
              stopsCovered: "4",
              stoppages: [
                {
                  name: "Source",
                  observation: "Late Start (15 Min)",
                  area: "La Palmera",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Jicarito",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Guatuso",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Bijagua",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "4",
          speed: "16 mph",
          fuelConsumed: "21 Gal",
          distanceCovered: "28 Miles",
          driver: "Luis Morales",
          tripStatus: "Ongoing",
          distance: "140 Miles",
          routeDetails: {
            route: "Route#6",
            occupancy: "32/40",
            videoUrl: "http://busVideo6",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Santa Rosa",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Canas",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "5 Min Delay",
                  area: "Tilarán",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Tronadora",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "Pending",
                  area: "Fortuna",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "3",
          route: "Route#3",
          timeStamp: generateRecentIsoTimestamp(),
        },
      ],
    },
    {
      busNo: "4",
      licensePlateNo: "CR7845",
      regionDepo: "Abu Dhabi",
      totalTrips: "1560",
      safetyScore: "90",
      totalPassengers: "26890",
      totalMiles: "1620",
      avgFuelEconomy: "42 Miles/Gal",
      nextMaintanance: "09-12-2025",
      trips: [
        {
          tripNo: "1",
          speed: "16 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "28 Miles",
          driver: "Maria Rodriguez",
          tripStatus: "Completed",
          distance: "140 Miles",
          routeDetails: {
            route: "Route#4",
            occupancy: "32/40",
            videoUrl: "http://busVideo4",
            routeStops: {
              totalStops: "7",
              stopsCovered: "7",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Mussafah, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Mohammed Bin Zayed City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "5 Min Delay",
                  area: "Baniyas, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Mafraq, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 4",
                  observation: "",
                  area: "Khalifa City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 5",
                  observation: "",
                  area: "Al Raha, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Yas Island, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        },
        {
          tripNo: "2",
          speed: "15 mph",
          fuelConsumed: "22 Gal",
          distanceCovered: "30 Miles",
          driver: "Carlos Jimenez",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#5",
            occupancy: "34/40",
            videoUrl: "http://busVideo5",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Al Shahama, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Al Bahyah, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "10 Min Delay",
                  area: "Al Samha, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Rahba, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 4",
                  observation: "",
                  area: "Shahama Gardens, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Saadiyat Island, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        },
        {
          tripNo: "3",
          speed: "17 mph",
          fuelConsumed: "21 Gal",
          distanceCovered: "32 Miles",
          driver: "Ana Rodriguez",
          tripStatus: "Ongoing",
          distance: "160 Miles",
          routeDetails: {
            route: "Route#6",
            occupancy: "29/40",
            videoUrl: "http://busVideo6",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Madinat Zayed, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Al Mirfa, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "5 Min Delay",
                  area: "Ghayathi, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Ruways, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Pending",
                  area: "Liwa Oasis, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        }
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "4",
          route: "Route#4",
          timeStamp: generateRecentIsoTimestamp()
        },
        {
          violationType: "rash driving",
          busNo: "4",
          route: "Route#4",
          timeStamp: generateRecentIsoTimestamp()
        }
      ]
    },
    {
      busNo: "5",
      licensePlateNo: "CR9056",
      regionDepo: "Abu Dhabi",
      totalTrips: "10",
      safetyScore: "82",
      totalPassengers: "21560",
      totalMiles: "1380",
      avgFuelEconomy: "35 Miles/Gal",
      nextMaintanance: "11-09-2025",
      trips: [
        {
          tripNo: "1",
          speed: "11 mph",
          fuelConsumed: "24 Gal",
          distanceCovered: "18 Miles",
          driver: "Carlos Sanchez",
          tripStatus: "Completed",
          distance: "95 Miles",
          routeDetails: {
            route: "Route#5",
            occupancy: "22/40",
            videoUrl: "http://busVideo5",
            routeStops: {
              totalStops: "4",
              stopsCovered: "4",
              stoppages: [
                {
                  name: "Source",
                  observation: "10 Min Delay",
                  area: "Mussafah, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Mohammed Bin Zayed City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "Traffic Jam",
                  area: "Baniyas, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Sheikh Zayed Grand Mosque, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        },
        {
          tripNo: "2",
          speed: "13 mph",
          fuelConsumed: "21 Gal",
          distanceCovered: "26 Miles",
          driver: "Luis Herrera",
          tripStatus: "Completed",
          distance: "110 Miles",
          routeDetails: {
            route: "Route#6",
            occupancy: "27/40",
            videoUrl: "http://busVideo6",
            routeStops: {
              totalStops: "5",
              stopsCovered: "5",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Khalifa City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Al Raha Beach, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "5 Min Delay",
                  area: "Yas Island, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Saadiyat Island, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Corniche, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        }
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "5",
          route: "Route#5",
          timeStamp: generateRecentIsoTimestamp()
        },
        {
          violationType: "overspeeding",
          busNo: "5",
          route: "Route#5",
          timeStamp: generateRecentIsoTimestamp()
        },
        {
          violationType: "rash driving",
          busNo: "5",
          route: "Route#5",
          timeStamp: generateRecentIsoTimestamp()
        }
      ]
    },
    {
      busNo: "6",
      licensePlateNo: "CR18",
      regionDepo: "Abu Dhabi",
      totalTrips: "1420",
      safetyScore: "87",
      totalPassengers: "24580",
      totalMiles: "1520",
      avgFuelEconomy: "37 Miles/Gal",
      nextMaintanance: "10-25-2025",
      trips: [
        {
          tripNo: "1",
          speed: "13 mph",
          fuelConsumed: "25 Gal",
          distanceCovered: "30 Miles",
          driver: "Ana Martinez",
          tripStatus: "Completed",
          distance: "160 Miles",
          routeDetails: {
            route: "Route#6",
            occupancy: "30/40",
            videoUrl: "http://busVideo6",
            routeStops: {
              totalStops: "8",
              stopsCovered: "8",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Mussafah, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Mohammed Bin Zayed City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "5 Min Delay",
                  area: "Baniyas, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Mafraq, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 4",
                  observation: "",
                  area: "Shakhbout City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 5",
                  observation: "",
                  area: "Khalifa City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 6",
                  observation: "",
                  area: "Al Raha Beach, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Yas Island, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        },
        {
          tripNo: "2",
          speed: "14 mph",
          fuelConsumed: "23 Gal",
          distanceCovered: "28 Miles",
          driver: "Javier Lopez",
          tripStatus: "Completed",
          distance: "135 Miles",
          routeDetails: {
            route: "Route#7",
            occupancy: "26/40",
            videoUrl: "http://busVideo7",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Al Shahama, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Al Bahyah, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "Traffic Jam",
                  area: "Al Samha, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Rahba, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 4",
                  observation: "",
                  area: "Shahama Gardens, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Saadiyat Island, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        },
        {
          tripNo: "3",
          speed: "12 mph",
          fuelConsumed: "26 Gal",
          distanceCovered: "20 Miles",
          driver: "Sofia Ramirez",
          tripStatus: "Completed",
          distance: "100 Miles",
          routeDetails: {
            route: "Route#8",
            occupancy: "29/40",
            videoUrl: "http://busVideo8",
            routeStops: {
              totalStops: "5",
              stopsCovered: "5",
              stoppages: [
                {
                  name: "Source",
                  observation: "10 Min Delay",
                  area: "Khalifa City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Al Shamkha, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Shakhbout City, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "Rain Delay (15 Min)",
                  area: "Al Mushrif, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Arrived",
                  area: "Corniche, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        },
        {
          tripNo: "4",
          speed: "16 mph",
          fuelConsumed: "22 Gal",
          distanceCovered: "35 Miles",
          driver: "Diego Vargas",
          tripStatus: "Ongoing",
          distance: "145 Miles",
          routeDetails: {
            route: "Route#9",
            occupancy: "33/40",
            videoUrl: "http://busVideo9",
            routeStops: {
              totalStops: "7",
              stopsCovered: "4",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Madinat Zayed, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 1",
                  observation: "",
                  area: "Al Mirfa, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Ghayathi, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 3",
                  observation: "5 Min Delay",
                  area: "Ruways, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 4",
                  observation: "",
                  area: "Liwa Oasis, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Stop 5",
                  observation: "",
                  area: "Mezaira'a, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                },
                {
                  name: "Destination",
                  observation: "Pending",
                  area: "Western Desert, Abu Dhabi, UAE",
                  coOrdinates: { lat: "", lng: "" },
                  timeStamp: generateRecentIsoTimestamp()
                }
              ]
            }
          }
        }
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "6",
          route: "Route#6",
          timeStamp: generateRecentIsoTimestamp()
        },
        {
          violationType: "rash driving",
          busNo: "6",
          route: "Route#8",
          timeStamp: generateRecentIsoTimestamp()
        }
      ]
    },
    {
      busNo: "7",
      licensePlateNo: "CR4562",
      regionDepo: "Abu Dhabi",
      totalTrips: "1350",
      safetyScore: "91",
      totalPassengers: "23890",
      totalMiles: "1480",
      avgFuelEconomy: "39 Miles/Gal",
      nextMaintanance: "23-11-2025",
      trips: [
        {
          tripNo: "1",
          speed: "17 mph",
          fuelConsumed: "28 Gal",
          distanceCovered: "35 Miles",
          driver: "Luis Fernandez",
          tripStatus: "Completed",
          distance: "170 Miles",
          routeDetails: {
            route: "Route#7",
            occupancy: "35/40",
            videoUrl: "http://busVideo7",
            routeStops: {
              totalStops: "10",
              stopsCovered: "10",
              stoppages: [
                { name: "Source", observation: "On Time", area: "Mussafah, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 1", observation: "", area: "Mohammed Bin Zayed City, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 2", observation: "5 Min Delay", area: "Baniyas, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 3", observation: "", area: "Al Mafraq, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 4", observation: "", area: "Shakhbout City, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 5", observation: "", area: "Khalifa City, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 6", observation: "", area: "Al Raha Beach, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 7", observation: "", area: "Yas Island, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 8", observation: "", area: "Saadiyat Island, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Destination", observation: "Arrived", area: "Corniche, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() }
              ]
            }
          }
        },
        {
          tripNo: "2",
          speed: "15 mph",
          fuelConsumed: "24 Gal",
          distanceCovered: "32 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#8",
            occupancy: "31/40",
            videoUrl: "http://busVideo8",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                { name: "Source", observation: "On Time", area: "Al Shahama, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 1", observation: "", area: "Al Bahyah, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 2", observation: "", area: "Al Samha, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 3", observation: "Traffic", area: "Al Rahba, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 4", observation: "", area: "Mina Zayed, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Destination", observation: "Arrived", area: "Sheikh Zayed Grand Mosque, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() }
              ]
            }
          }
        },
        {
          tripNo: "3",
          speed: "16 mph",
          fuelConsumed: "22 Gal",
          distanceCovered: "28 Miles",
          driver: "Fatima Khalid",
          tripStatus: "Ongoing",
          distance: "140 Miles",
          routeDetails: {
            route: "Route#9",
            occupancy: "29/40",
            videoUrl: "http://busVideo9",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                { name: "Source", observation: "On Time", area: "Madinat Zayed, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 1", observation: "", area: "Al Mirfa, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 2", observation: "", area: "Ghayathi, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 3", observation: "5 Min Delay", area: "Ruways, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Destination", observation: "Pending", area: "Liwa Oasis, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() }
              ]
            }
          }
        }
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "7",
          route: "Route#7",
          timeStamp: generateRecentIsoTimestamp()
        },
        {
          violationType: "signal jump",
          busNo: "7",
          route: "Route#8",
          timeStamp: generateRecentIsoTimestamp()
        },
        {
          violationType: "harsh braking",
          busNo: "7",
          route: "Route#9",
          timeStamp: generateRecentIsoTimestamp()
        }
      ]
    },
    {
      busNo: "8",
      licensePlateNo: "CR7893",
      regionDepo: "Abu Dhabi",
      totalTrips: "1280",
      safetyScore: "94",
      totalPassengers: "22560",
      totalMiles: "1350",
      avgFuelEconomy: "41 Miles/Gal",
      nextMaintanance: "24-10-2025",
      trips: [
        {
          tripNo: "1",
          speed: "15 mph",
          fuelConsumed: "19 Gal",
          distanceCovered: "24 Miles",
          driver: "Elena Vargas",
          tripStatus: "Completed",
          distance: "110 Miles",
          routeDetails: {
            route: "Route#8",
            occupancy: "26/40",
            videoUrl: "http://busVideo8",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                { name: "Source", observation: "On Time", area: "Mussafah, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 1", observation: "", area: "Mohammed Bin Zayed City, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 2", observation: "5 Min Delay", area: "Baniyas, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 3", observation: "", area: "Al Mafraq, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 4", observation: "", area: "Shakhbout City, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Destination", observation: "Arrived", area: "Khalifa City, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() }
              ]
            }
          }
        },
        {
          tripNo: "2",
          speed: "12 mph",
          fuelConsumed: "21 Gal",
          distanceCovered: "22 Miles",
          driver: "Ricardo Morales",
          tripStatus: "Completed",
          distance: "105 Miles",
          routeDetails: {
            route: "Route#9",
            occupancy: "28/40",
            videoUrl: "http://busVideo9",
            routeStops: {
              totalStops: "5",
              stopsCovered: "5",
              stoppages: [
                { name: "Source", observation: "On Time", area: "Al Ain, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 1", observation: "", area: "Al Jimi, Al Ain, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 2", observation: "10 Min Delay", area: "Al Hili, Al Ain, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 3", observation: "", area: "Zakher, Al Ain, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Destination", observation: "Arrived", area: "Al Ain Oasis, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() }
              ]
            }
          }
        },
        {
          tripNo: "3",
          speed: "14 mph",
          fuelConsumed: "23 Gal",
          distanceCovered: "27 Miles",
          driver: "Gabriela Herrera",
          tripStatus: "Completed",
          distance: "125 Miles",
          routeDetails: {
            route: "Route#10",
            occupancy: "31/40",
            videoUrl: "http://busVideo10",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                { name: "Source", observation: "On Time", area: "Madinat Zayed, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 1", observation: "", area: "Al Mirfa, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 2", observation: "", area: "Ghayathi, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 3", observation: "5 Min Delay", area: "Ruways, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Stop 4", observation: "", area: "Liwa Oasis, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() },
                { name: "Destination", observation: "Arrived", area: "Qasr Al Sarab Desert Resort, Abu Dhabi, UAE", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentIsoTimestamp() }
              ]
            }
          }
        }
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "8",
          route: "Route#8",
          timeStamp: generateRecentIsoTimestamp()
        },
        {
          violationType: "signal jump",
          busNo: "8",
          route: "Route#9",
          timeStamp: generateRecentIsoTimestamp()
        }
      ]
    },
  ],
};

export default busInfo;
